/* =============================================
   Paula's Choice — Centralized Scroll Animations
   IntersectionObserver reveal + scroll parallax
   Desktop only (disabled on mobile for performance)
   ============================================= */
(function() {
  'use strict';

  /* ── Mobile check: skip everything on small screens ── */
  var isMobile = window.innerWidth < 768;
  if (isMobile) return;

  /* ── Scroll Reveal ── */
  function initScrollReveal() {
    var elements = document.querySelectorAll('[data-pc-animate]');
    if (!elements.length) return;

    /* Set transition duration & delay from data attributes */
    elements.forEach(function(el) {
      var duration = parseInt(el.dataset.pcDuration) || 600;
      var delay = parseInt(el.dataset.pcDelay) || 0;
      el.style.transitionDuration = duration + 'ms';
      el.style.transitionDelay = delay + 'ms';
    });

    /* Auto-stagger: parent with data-pc-stagger applies incremental delays to children */
    var staggerParents = document.querySelectorAll('[data-pc-stagger]');
    staggerParents.forEach(function(parent) {
      var staggerMs = parseInt(parent.dataset.pcStagger) || 100;
      var children = parent.querySelectorAll('[data-pc-animate]');
      children.forEach(function(child, i) {
        var existingDelay = parseInt(child.dataset.pcDelay) || 0;
        child.style.transitionDelay = (existingDelay + staggerMs * i) + 'ms';
      });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('pc--revealed');
            observer.unobserve(entry.target);
          }
        });
      }, {
        root: null,
        rootMargin: '0px 0px -60px 0px',
        threshold: 0.1
      });

      elements.forEach(function(el) {
        observer.observe(el);
      });
    } else {
      /* Fallback: show everything */
      elements.forEach(function(el) {
        el.classList.add('pc--revealed');
      });
    }
  }

  /* ── Parallax ── */
  function initParallax() {
    var parallaxEls = document.querySelectorAll('[data-pc-parallax]');
    if (!parallaxEls.length) return;

    var ticking = false;

    function updateParallax() {
      var scrollY = window.pageYOffset;
      var windowH = window.innerHeight;

      parallaxEls.forEach(function(el) {
        var rect = el.getBoundingClientRect();
        var elTop = rect.top + scrollY;
        var elH = rect.height;

        /* Only process if element is near or in the viewport */
        if (scrollY + windowH < elTop - 200 || scrollY > elTop + elH + 200) return;

        var speed = parseFloat(el.dataset.pcParallax) || 0;
        /* Calculate offset: 0 when element center is at viewport center */
        var center = elTop + elH / 2;
        var viewCenter = scrollY + windowH / 2;
        var offset = (viewCenter - center) * speed;

        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });

      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });

    /* Initial position */
    updateParallax();
  }

  /* ── Init ── */
  function init() {
    initScrollReveal();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
